/** @format */

import axios from 'axios';
import NProgress from 'nprogress';
import store from '../store';
import * as user from '@/store/modules/user.js';
const baseURL = (process.env.NODE_ENV === 'development') ? 'https://mgsauth.app.localhost/api': 'https://mgs-auth.lcainswebdeveloper.co.uk/api';
const apiClient = axios.create({
	baseURL,
	withCredentials: false, // This is the default
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
	timeout: 99999999
});

const objectGet = (obj, ...path) => {
	let i = 0;
	let len = path.length - 1;
	while (obj != undefined && i < len) {
		obj = obj[path[i]];
		i++;
	}
	return obj && i === len ? obj[path[i]] : undefined;
};

apiClient.interceptors.request.use((config) => {
	if (objectGet(user, 'state', 'user', 'access_token') != undefined) {
		config.headers.common['Authorization'] = `Bearer ${user.state.user.access_token}`;
	}
	NProgress.start();
	store.dispatch('validation/reset')
	return config;
});

apiClient.interceptors.response.use(
	(response) => {
		NProgress.done();
		return response;
	},
	(error) => {
		if (error.response.status === 401) {
			// if we catch a 401 error
			store.dispatch('logout'); // force a log out
		}

		if (error.response.data) {
			store.dispatch('notification/add', {type: 'error', message: error.response.data.message});
		}

		if (error.response.status == 422){
			store.dispatch('validation/addErrors', error.response.data.errors);
		}
		NProgress.done();
		return Promise.reject(error); // reject the Promise, with the error as the reason
	}
);

export default {
	register(credentials) {
		return apiClient.post('/register', credentials);
	},
	async login(credentials) {
		const data = await apiClient.post('/login', credentials);
		axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
		return data;
	},
	addCourse(data) {
		return apiClient.post('/courses', data);
	},
	editCourse({golfCourse, payload}) {
		return apiClient.put(`/courses/${golfCourse.uuid}`, payload);
	},
	addCourseTee({golfCourse, payload}) {
		return apiClient.post(`/courses/${golfCourse.uuid}/tee`, payload);
	},
	editCourseTee({golfCourse, courseTee}) {
		return apiClient.put(`/courses/${golfCourse.uuid}/tee/${courseTee.uuid}`, courseTee);
	},
	getCourses() {
		return apiClient.get('/courses');
	},
	getCourse(uuid) {
		return apiClient.get(`/courses/${uuid}`);
	},
	getRounds() {
		return apiClient.get('/rounds');
	},
	getStatsRounds() {
		return apiClient.get('/stats-rounds');
	},
	getShotAnalysis() {
		return apiClient.get('/shot-analysis');
	},
	getRound(uuid) {
		return apiClient.get(`/rounds/${uuid}`);
	},
	addRound(data) {
		return apiClient.post('/rounds', data.payload);
	},
	editRound({roundUuid, payload}) {
		return apiClient.put(`/rounds/${roundUuid}`, payload);
	},
	getShotMetaData() {
		return apiClient.get(`/shot-meta`);
	},
	addShot(roundUuid, data) {
		return apiClient.post(`/rounds/${roundUuid}/hole/${data.hole_uuid}/shots`, data);
	}
};
